import React from 'react'
import reactStamp from 'react-stamp'
import SidePanelItem from './SidePanelItem'
import './side-panel.css'

export default reactStamp(React).compose({

    render() {
        return (
            <div className="side-panel-container">
                {this.createSidePanelItem("Home", this.props.activateHome)}
                {this.createSidePanelItem("Health", this.props.activateHealth)}
                {this.createSidePanelItem("Appointments", this.props.activateAppointments)}
                {this.createSidePanelItem("Devices", this.props.activateDevices)}
                <br/>
            </div>
        )
    },

    createSidePanelItem(name, onclick){
        return (
            <SidePanelItem name={name} active={name==this.props.active} onclick={onclick}/>
        )
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/components/SidePanel/index.js
 **/